import React, { useEffect, useState } from "react";
import CardInfo from "../../components/cards/cardInfo";
import DivisionCmp from "../../components/cards/DivisionCmp";
import { ColumnModel } from "../../models/common.model";
import "./sale.css";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Box, Button, Grid, Typography } from "@mui/material";
import TwoColumnCard from "../../components/cards/TwoColumnCard";
import CustomisedButton from "../../components/button/button";
import CountDown from "../../components/countDownCmp/countDown";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import { RegisterLoanBySupplierRequest } from "../../models/loan.model";
import * as Yup from "yup";
import TableCreator from "../../components/table/tableCreator";
import { useMutation } from "react-query";
import {
  IGetByKeyResponse,
  ISaleItemRequest,
  IVerifyInvoiceDetailsByCustomerResponse,
} from "../../models/sale.model";
import {
  cancelInvoice,
  getByKey,
  sendRequestForInvoiceOtp,
  verifyInvoiceDetailsByCustomer,
} from "../../services/sale.service";
import {
  IInvoiceResponse,
  IVerifyInvoiceDetailsByCustomerRequest,
} from "../../models/sale.model";
import { useHistory } from "react-router-dom";
import Otp from "../login/otp";
import { SALE_INVOICE_OTP, SALE_ITEM } from "../../config/cacheKey";
import ShowErrorsModal from "../../components/modals/showErrorsModal";
import { SendOtpResponse } from "../../models/security.model";
import ConfirmModal from "../../components/modals/ConfirmModal";
import CancelModals from "../../store/component/modals/modal/cancelModals";
export default function SaleFactorOtpStep() {
  const [data, setData] = React.useState<IGetByKeyResponse>();
  const columns: readonly ColumnModel[] = [
    { id: "saleItemGroupTitle", label: "گروه کالا" },
    { id: "title", label: " عنوان کالا" },
    { id: "quantity", label: " مقدار (عدد)" },
    {
      id: "saleItemTotalAmount",
      label: " مبلغ کل (ريال)",
      hasFormat: true,
      format: (value: number) => {
        return value?.toLocaleString("fa");
      },
    },
  ];
  let request = JSON.parse(
    localStorage.getItem(SALE_ITEM)!
  ) as ISaleItemRequest | null;
  useEffect(() => {
    GetByKeyMutate({
      saleKey: request?.saleKey!,
      branchId: request?.branchId!,
      customerPersonId: request?.customerPersonId!,
    });
  }, []);
  const { mutate: GetByKeyMutate } = useMutation(getByKey, {
    onSuccess: (data: IGetByKeyResponse) => {
      if (data) {
        setData(data);
      }
    },
  });
  const history = useHistory();
  const handleContinue = () => {
    history.push(`/sale/ProformaInvoice`);
  };
  const table = (
    <div className="px-8">
      <div className="labelFactorEdit">
        {" "}
        <span onClick={handleContinue}>
          {" "}
          <EditOutlinedIcon /> ویرایش فاکتور
        </span>
      </div>
      <TableCreator
        columns={columns}
        data={data?.saleItems}
        pageInfo={undefined}
        // handleChangePagination={handleChangePagination}
        // currentPaginationInfo={currentPaginationInfo}
      />
    </div>
  );
  return (
    <div>
      <CardInfo
        customerFullName={data?.customerFullName}
        customerMobileNumber={data?.customerMobileNumber}
        customerWalletAmount={data?.customerWalletAmount}
        expirationDate_Persian={data?.expirationDate_Persian}
        saleDate_Persian={data?.saleDate_Persian}
        issuanceInvoiceDate_Persian={data?.issuanceInvoiceDate_Persian}
        confirmInvoiceDate_Persian={data?.confirmInvoiceDate_Persian}
        branchAddress={data?.branchAddress}
        saleType={data?.saleType}
        saleTypeTitle={data?.saleTypeTitle}
        branchTitle={data?.branchTitle}
        storeTitle={data?.storeTitle}
        storeUrl={data?.storeUrl}
      />
      <div className="mTop40">
        <DivisionCmp title="کالاهای درخواستی" child={table} />
      </div>
      <Grid
        container
        columns={{ xs: 4, sm: 8, md: 12 }}
        className="mTop40"
        style={{ width: "99%", margin: "0 auto" }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "stretch",
          }}
        >
          <DivisionCmp
            title="جزییات پرداخت"
            child={
              <div
                className="p-7"
                style={{
                  // maxHeight: "20rem",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <TwoColumnCard
                  saleAmount={data?.saleAmount!}
                  cashAmount={data?.cashAmount!}
                  creditAmount={data?.creditAmount!}
                  totalSettlementAmount={data?.totalSettlementAmount!}
                />
              </div>
            }
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "stretch",
          }}
        >
          <DivisionCmp
            title="تایید پرداخت"
            child={
              <div
                className="p-12"
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <PaymentConfirmation request={request} saleData={data} />
              </div>
            }
          />
        </Grid>
      </Grid>
    </div>
  );
}
const PaymentConfirmation = (request: any) => {
  let saleInvoiceOtp_cache = JSON.parse(
    localStorage.getItem(SALE_INVOICE_OTP)!
  ) as SendOtpResponse | null;
  const history = useHistory<any>();
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalVerify, setOpenModalVerify] = React.useState(false);
  const [saleInvoiceOtp, setSaleInvoiceOtp] = React.useState<SendOtpResponse>(
    saleInvoiceOtp_cache!
  );
  const [openCancelFactorModal, setOpenCancelFactorModal] = useState<boolean>(
    false
  );
  const [responseDataFactor, setResponseDataFactor] = React.useState<boolean>();
  const [finalized, setFinalized] = React.useState<string>("");
  let historyValue = JSON.parse(
    localStorage.getItem(SALE_ITEM)!
  ) as ISaleItemRequest | null;

  const [error, setError] = React.useState<string[]>();
  const validationFatcorNumber = Yup.object().shape({
    otp: Yup.string()
      .required("فیلد اجباری است.")
      .matches(/^[0-9]+$/, "کد استعلامی عدد می باشد."), //.min(5).max(5)
  });
  const { mutate: SendRequestForInvoiceOtpMutate } = useMutation(
    sendRequestForInvoiceOtp,
    {
      onSuccess: (data: SendOtpResponse) => {
        if (data) {
          setSaleInvoiceOtp(data);
        }
      },
    }
  );
  const handleConfirmModal = (values: any) => {
    VerifyInvoiceDetailsByCustomerMutate(values);
  };
  const { mutate: VerifyInvoiceDetailsByCustomerMutate } = useMutation(
    verifyInvoiceDetailsByCustomer,
    {
      onSuccess: (data: IVerifyInvoiceDetailsByCustomerResponse) => {
        if (data.isValid) {
          history.push({
            pathname: `/sale/SaleFactorFilesStep`,
            state: {
              branchId: request.request?.branchId!,
              customerPersonId: request.request?.customerPersonId!,
              saleKey: request.request?.saleKey!,
            },
          });
          if (!data.isValid) {
            setOpenModal(true);
            setError(data.validationIssues);
          }
        }
      },
    }
  );

  const handelDetailDeleteFactor = () => {
    setOpenCancelFactorModal(true);
  };
  useEffect(() => {
    if (responseDataFactor === true) {
      history.push({
        pathname: `/welcome`,
      });
    }
  }, [finalized]);
  return (
    <Formik
      validateOnMount={true}
      initialValues={new IVerifyInvoiceDetailsByCustomerRequest()}
      // validationSchema={validationFatcorNumber}
      onSubmit={async (values) => {
        values.otp = values.otp;
        values.branchId = request.request.branchId;
        values.customerPersonId = request.request.customerPersonId;
        values.saleKey = request.request.saleKey;
        setOpenModalVerify(true);
      }}
    >
      {({
        handleSubmit,
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
      }) => (
        <form
          onSubmit={handleSubmit}
          style={{
            maxWidth: "34rem",
            margin: "0 auto",

            maxHeight: "15rem",
            overflowY: "auto",
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSubmit();
            }
          }}
        >
          <div>
            <Typography className="textCenter  mbottom20">
              <span>
                با وارد کردن رمز تایید ارسال شده برای متقاضی و فشردن دکمه
                <b> "تایید پرداخت" </b> خرید نهایی شده و کالا میبایست تحویل
                مشتری گردد.
              </span>
            </Typography>
          </div>
          <div className="mbottom20" style={{ textAlign: "center" }}>
            <MaterialTextFieldComponent
              autoFocus={true}
              helperText={touched.otp ? errors.otp : ""}
              error={touched.otp && Boolean(errors.otp)}
              placeHolder={"کد تایید "}
              label={"کد تایید "}
              required={true}
              value={values.otp}
              onChange={handleChange}
              onBlur={handleBlur}
              name="otp"
              id="otp"
              autoComplete="off"
              type="tel"
              inputProps={{ maxLength: saleInvoiceOtp?.otpLength! }}
            />
            <CountDown
              countDownValue={saleInvoiceOtp?.otpLifetime!}
              resendOtp={() => {
                SendRequestForInvoiceOtpMutate({
                  saleKey: request?.request.saleKey,
                  customerPersonId: request?.request.customerPersonId,
                  branchId: request?.request.branchId,
                });
              }}
            />
          </div>

          <div>
            <Grid container xs={12}>
              <Grid item xs={6}>
                <CustomisedButton
                  title={"تایید پرداخت"}
                  disable={
                    values?.otp?.length! < saleInvoiceOtp?.otpLength! ||
                    values?.otp === undefined ||
                    values?.otp === null
                  }
                  onClick={() => {}}
                  type="submit"
                />
              </Grid>
              {/* {request?.saleData?.saleStatusId !== "WaitForFactor" && ( */}
              <Grid item xs={6} style={{ textAlign: "end" }}>
                <Button
                  type="submit"
                  onClick={() => handelDetailDeleteFactor()}
                  // disabled={saleItems!.length > 0 ? false : true}
                  className={
                    // saleItems!.length > 0
                    //   ?
                    "btn activatedErrorButton defaultHeight height42"
                    // : "btnForm deactivatedErrorButton Vazirmatn "
                  }
                  style={{ width: "92%" }}
                >
                  ابطال پیش فاکتور
                </Button>
              </Grid>
              {/* )} */}
            </Grid>
          </div>
          <ShowErrorsModal
            openModal={openModal}
            setOpenModal={setOpenModal}
            validationMessages={error}
            firstPartOfTitle=" "
            boldTitle=""
            secondPartOfTitle=""
          />
          <ConfirmModal
            openModal={openModalVerify}
            setOpenModal={setOpenModalVerify}
            handelVerify={() => handleConfirmModal(values)}
          />
          {openCancelFactorModal && (
            <CancelModals
              setOpenCancelModal={setOpenCancelFactorModal}
              openCancelModal={openCancelFactorModal}
              serviceName={cancelInvoice}
              requestModel={{
                branchId: historyValue?.branchId,
                customerPersonId: historyValue?.customerPersonId,
                saleKey: historyValue?.saleKey,
              }}
              response={"boolean"}
              setFinalized={setFinalized}
              setResponseData={setResponseDataFactor}
            />
          )}
        </form>
      )}
    </Formik>
  );
};
